import React, { useCallback } from 'react';
import { Icon } from '@vectord/components';
import { NavLink, useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import homeIcon from 'assets/icons/home.svg';
import styles from './NavBar.module.scss';

function NavBar({
  title,
  isSticky = true,
  homeUrl = '/',
  showHomeButton = true,
  showBackButton = true,
  children,
  id,
  className,
}) {
  const navigate = useNavigate();

  const handleBackClick = useCallback(() => {
    // to get the previous route
    navigate(-1);
  }, [navigate]);

  return (
    <div
      id={id}
      className={classNames(styles.root, className, {
        [styles.sticky]: isSticky,
      })}
    >
      <div className={styles.heading}>
        {showBackButton && (
          <Icon
            name="arrow-left"
            className="h3 m-l-xs m-r-xs cursor"
            onClick={handleBackClick}
          />
        )}
        {showHomeButton && (
          <NavLink to={homeUrl}>
            <img
              src={homeIcon}
              alt="home-icon"
              className="m-r-xs p-t-xxs"
            />
          </NavLink>
        )}
        <span className={styles.title}>{title}</span>
      </div>
      {children && <div>{children}</div>}
    </div>
  );
}

export default NavBar;
